import { render, staticRenderFns } from "./BattleCard.vue?vue&type=template&id=56a9f5b5&"
import script from "./BattleCard.vue?vue&type=script&lang=ts&"
export * from "./BattleCard.vue?vue&type=script&lang=ts&"
import style0 from "./BattleCard.vue?vue&type=style&index=0&id=56a9f5b5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports